
export default function ToastHost({ toast, onClose }) {
  if (!toast) return null;

  const styles =
    toast.kind === "error"
      ? "border-red-200 bg-red-50 text-red-900"
      : toast.kind === "success"
      ? "border-emerald-200 bg-emerald-50 text-emerald-900"
      : "border-slate-200 bg-white text-slate-900";

  const dot =
    toast.kind === "error"
      ? "bg-red-500"
      : toast.kind === "success"
      ? "bg-emerald-500"
      : "bg-slate-500";

  return (
    <div className="sticky top-4 z-10 pointer-events-none">
      <div className="max-w-2xl pointer-events-auto">
        <div className="border rounded-2xl p-3 shadow-sm animate-[fadeIn_.2s_ease-out] bg-white/90 backdrop-blur-sm">
          <div className={`border rounded-xl p-3 ${styles}`}>
            <div className="flex items-start gap-3">
              <div className={`mt-1.5 w-2.5 h-2.5 rounded-full ${dot}`} />
              <div className="flex-1">
                {toast.title && <div className="font-semibold">{toast.title}</div>}
                {toast.message && <div className="text-sm opacity-90">{toast.message}</div>}
              </div>
              <button className="text-sm px-2 py-1 rounded-lg hover:bg-black/5" onClick={onClose}>
                ✕
              </button>
            </div>
          </div>
        </div>

        <style>{`@keyframes fadeIn{from{opacity:0;transform:translateY(-6px)}to{opacity:1;transform:translateY(0)}}`}</style>
      </div>
    </div>
  );
}
